<ng-container *ngIf="vm$ | async as vm">
    <section>
        <header class="header-school-info bg-primary">
            <div class="container">
                <img *ngIf="vm.hasSchoolLogoImage" [src]="vm.schoolLogoImageURI" alt="School Icon Logo" id="school-icon-logo" />
                <h4 [ngClass]="{'mobile-hide-school-name': vm.hasSchoolLogoImage}"><b>{{vm.gallerySchoolName}}</b></h4>
            </div>
        </header>
        <div class="header-image">
            <img id="header-image" [src]="vm.headerImageURI" alt="header image" />
        </div>
    </section>
    <section class="pt-25">
        <div class="container gallery-intro">
            <div>
                <h3 class="text-primary"><b>{{vm.galleryHeadline}}</b></h3>
            </div>
            <div [innerHTML]="vm.galleryParagraphText">
            </div>
        </div>
    </section>

    <section class="pt-25">
        <div class="container">
            <div class="flex-container">
                <h4 class="flex-item"><b>Student Stories</b></h4>
                <div class="flex-divider"></div>
                <div class="flex-item">
                    <h5><b>Sort by:</b></h5>&nbsp;
                    <kendo-dropdownlist [data]="vm.sortOptions"
                                        (valueChange)="onStateChange(vm.state)"
                                        [(ngModel)]="selectedValue"></kendo-dropdownlist>
                </div>
            </div>
        </div>
    </section>
    <section class="pt-20">
        <div class="container">
            <div class="row">
                <div class="w-100">
                    <div class="card-deck">
                        <kendo-card class="card"
                                    *ngFor="let galleryItem of vm.gallery; let i = index"
                                    tabindex="0"
                                    attr.aria-label="Gallery Item At {{i + 1}}">
                            <kendo-card-header class="k-hbox w-100">
                                <ng-container *ngIf="galleryItem.imageUrl">
                                    <kendo-avatar width="105px"
                                                  height="105px"
                                                  attr.alt="Avatar At {{i + 1}}"
                                                  [imageSrc]="galleryItem.imageUrl"
                                                  [shape]="'circle'"></kendo-avatar>
                                </ng-container>
                                <ng-container *ngIf="!galleryItem.imageUrl">
                                    <span class="avatar flex-center" id="initials-{{i + 1}}">
                                        {{galleryItem.studentInitials}}
                                    </span>
                                </ng-container>

                            </kendo-card-header>
                            <kendo-card-body>
                                <div id="name-section-{{i + 1}}" class="flex-center">
                                    <h3 id="name-{{i + 1}}" class="w-80 text-center">{{galleryItem.firstName}} {{galleryItem.lastName}}</h3>
                                </div>
                                <div id="major-and-yearInSchool-{{i + 1}}" class="flex-center">
                                    <div class="text-center w-80">
                                        <span id="yearInSchool-{{i + 1}}">{{galleryItem.yearInSchool}}</span><br />
                                        <span id="major-{{i + 1}}">{{galleryItem.major}}</span>
                                    </div>
                                </div>
                                <div class="flex-center pt-15">
                                    <span class="w-80 flex-center" id="introText-{{i + 1}}">
                                        {{galleryItem.introText | truncateText:150 }}
                                    </span>
                                </div>
                            </kendo-card-body>
                            <kendo-card-footer>
                                <div class="read-more" id="read-more-section-{{i + 1}}">
                                    <button id="read-more-{{i + 1}}"
                                            class="btn btn-primary"
                                            (click)="goToCampaign(galleryItem.campaignId)"
                                            (keydown.space)="goToCampaign(galleryItem.campaignId)"
                                            (keydown.enter)="goToCampaign(galleryItem.campaignId)">
                                        Read More
                                    </button>
                                </div>
                            </kendo-card-footer>
                        </kendo-card>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <section class="pager-section">
        <div class="flex-center">
            <kendo-datapager [style.width.%]="100"
                             [pageSize]="vm.state.take"
                             [skip]="vm.state.skip"
                             [pageSizeValues]="[12,24,36,48]"
                             [total]="vm.total"
                             (pageChange)="onStateChange($event)">
            </kendo-datapager>
        </div>
    </section>
</ng-container>